import * as React from 'react';
import { useApplicationContext } from 'shared/containers/ApplicationContext';

const GALLERY_PHOTO_SLIDE_METRIC = 'gallery.photo_slide_change';

export function useGalleryPhotoSlideTelemetry() {
  const { telemetry } = useApplicationContext();
  const previousSlideRef = React.useRef(0);

  const trackPhotoSlideChange = React.useCallback(
    (index: number) => {
      if (index !== previousSlideRef.current) {
        telemetry.increment(GALLERY_PHOTO_SLIDE_METRIC);
        previousSlideRef.current = index;
      }
    },
    [telemetry],
  );

  return trackPhotoSlideChange;
}
